export default "__VITE_ASSET__DCGSFnKF__"